/**
 * MiniLanguageToggle
 *
 * Small inline EN/ES toggle for pages that don't render the global
 * Header (privacy, terms, safety, for-organizations). Mirrors the
 * style of the Header switch but is purely a thumb-and-label control,
 * meant to live inline within page content.
 */
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export const MiniLanguageToggle = ({ className = '' }) => {
  const { isSpanish, toggleLanguage, isTranslating } = useLanguage();

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      disabled={isTranslating}
      data-testid="mini-language-toggle"
      aria-label={isSpanish ? 'Cambiar a inglés' : 'Switch to Spanish'}
      className={[
        'inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium',
        'bg-card hover:border-[#00E5CC] hover:bg-[#00E5CC]/10 transition-colors',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      ].join(' ')}
    >
      <span className={!isSpanish ? 'font-bold text-[#00A896]' : 'text-muted-foreground'}>EN</span>
      <span aria-hidden className="text-muted-foreground">·</span>
      <span className={isSpanish ? 'font-bold text-[#00A896]' : 'text-muted-foreground'}>ES</span>
    </button>
  );
};

export default MiniLanguageToggle;
